<app-dashboard-layout [notDashboard]="true" [loading]="refreshing">
  <header class="text-lg w-full pb-6 gap-8 md:text-xl">
    Running Elections
    <div *ngIf="!elections.length && !refreshing" class="text-sm text-gray-600">
      Please select an election
    </div>
  </header>

  <app-notification-alert [data]="notification"></app-notification-alert>

  <section *ngIf="refreshing">
    <div class="border rounded-md bg-gray-300 h-16 my-8 animate-pulse"></div>
    <div class="border rounded-md bg-gray-300 h-16 my-8 animate-pulse"></div>
    <div
      class="border rounded-md mx-auto max-w-md bg-gray-300 h-8 my-8 animate-pulse"
    ></div>
  </section>

  <app-no-content
    *ngIf="!elections.length && !refreshing"
    caption="No running election"
  >
  </app-no-content>

  <div class="flex flex-col gap-4">
    <a
      *ngFor="let item of elections"
      (click)="submitVotes(item.ElectionName)"
      class="bg-white rounded-md cursor-pointer border-2 p-4 transform duration-200 block group md:p-6 hover:border-primary hover:bg-primary/5 hover:scale-95"
    >
      <div
        class="font-medium text-base pb-1 capitalize group-hover:text-primary"
      >
        {{ item.ElectionName }}
      </div>
      <section class="flex gap-8 justify-between items-end">
        <div class="flex flex-col text-sm text-gray-500 gap-2">
          <div class="flex gap-2 items-center">
            <div class="text-lg material-icons">schedule</div>
            <div>
              {{ item.StartTime | date : "MMM d, y, h:mm a" }}
            </div>
          </div>
          <div class="flex gap-2 items-center">
            <div class="text-lg material-icons">hourglass_bottom</div>
            <div>
              {{ item.EndTime | date : "MMM d, y, h:mm a" }}
            </div>
          </div>
          <div class="flex gap-2 items-center">
            <div class="text-lg material-icons">groups</div>
            <div>{{ item.RegisteredVoters }} Eligible Voters</div>
          </div>
        </div>

        <button
          class="bg-primary rounded font-medium text-white text-sm py-2 px-4"
        >
          Vote now
        </button>
      </section>
    </a>
  </div>
</app-dashboard-layout>
